import React, { useEffect, useState } from 'react';
import { Card, Col, ListGroup, Row } from 'react-bootstrap';
import {
      CardHeader,
      CardLinks,
      CardTitle
} from '../../styles/components/common/Table';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import ItemShow from '../../components/Form/ItemShow';
import { LinkButton } from '../../styles/components/common/Button';
import toast from 'react-hot-toast';
import { Loading } from '../../components/Loading';

const FeedbackShow = () => {
      const { feedbackId } = useParams();
      const [enquiry, setEnquiry] = useState([]);
      const [loadingData, setLoadingData] = useState(false);

      const token = JSON.parse(localStorage.getItem('token'));

      const loadCategories = async () => {
            setLoadingData(true);

            await axios
                  .get(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/feedbacks/${feedbackId}`,
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              setEnquiry(response.data.feedback);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoadingData(false);
      };

      useEffect(() => {
            loadCategories();
      }, []);

      return (
            <>
                  <Row>
                        <Col lg={12}>
                              <Card>
                                    <CardHeader>
                                          <CardTitle>Feedback Detail</CardTitle>
                                          <CardLinks>
                                                <LinkButton to="/dashboard/feedbacks">
                                                      Back
                                                </LinkButton>
                                          </CardLinks>
                                    </CardHeader>
                                    <Card.Body>
                                          {!loadingData ? (
                                                <Row>
                                                      <Col lg={6}>
                                                            <ListGroup>
                                                                  <ItemShow
                                                                        title="Full Name"
                                                                        value={`${enquiry.first_name} ${enquiry.last_name}`}
                                                                  />
                                                                  <ItemShow
                                                                        title="Email"
                                                                        value={
                                                                              enquiry.email
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Phone No."
                                                                        value={
                                                                              enquiry.phone_number
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Address"
                                                                        value={
                                                                              enquiry.address
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Occupation"
                                                                        value={
                                                                              enquiry.occupation
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Project Name"
                                                                        value={
                                                                              enquiry.project_name
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Project Type"
                                                                        value={
                                                                              enquiry.project_type
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="How do you hear about us?"
                                                                        value={
                                                                              enquiry.influence
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Feedback"
                                                                        value={
                                                                              enquiry.feedback
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Quality of Product"
                                                                        value={
                                                                              enquiry.product_feedback
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Quality of Service"
                                                                        value={
                                                                              enquiry.service_feedback
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Date"
                                                                        value={
                                                                              enquiry.date
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Message"
                                                                        value={
                                                                              enquiry.message
                                                                        }
                                                                  />
                                                            </ListGroup>
                                                      </Col>
                                                </Row>
                                          ) : (
                                                <>
                                                      <div
                                                            className="text-center d-flex align-items-center justify-content-center w-100"
                                                            style={{
                                                                  height: '30vh'
                                                            }}
                                                      >
                                                            <Loading />
                                                      </div>
                                                </>
                                          )}
                                    </Card.Body>
                              </Card>
                        </Col>
                  </Row>
            </>
      );
};

export default FeedbackShow;
